// src/App.js (or App.jsx)
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Layout
import Navbar from "../src/components/navbar/Navbar";
import Footer from "../src/components/footer/Footer";

// Pages
import Main from "../src/components/pages/main/Main"; // Landing: Home + About + Contacts
import Products from "../src/components/pages/products/Products"; // Full page
import Projects from "../src/components/pages/projects/Projects"; // Full page

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/products" element={<Products />} />
        <Route path="/projects" element={<Projects />} />
        {/* Optional: 404 fallback */}
        {/* <Route path="*" element={<Main />} /> */}
      </Routes>
      <Footer />
    </>
  );
}
